import { render } from "./PhoneFieldEditable.vue?vue&type=template&id=2d394280"
import script from "./PhoneFieldEditable.vue?vue&type=script&lang=js"
export * from "./PhoneFieldEditable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__